import axiosHeader from '_common/runs/axios';
import BaseService from '_services/rest/base';
import config from '_config';
import axios from 'axios';

class ResellerService extends BaseService {
  constructor() {
    super();
  }

  getApiKey() {
    return config.GOOGLE_API_KEY;
  }

  getUrl() {
    return `${super.getUrl()}api/reseller`;
  }

  getUrlSave(id, url = '/') {
    if (id) {
      return {
        url: `${this.getUrl()}/${url}${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${url}`,
      method: 'POST',
    };
  }

  getCoordenates(address) {
    let formatted = `${address.address} ${address.district} ${address.city} ${address.state}`;
    formatted = formatted.replace(' ', '+');
    if (formatted !== '') {
      axios.defaults.headers.common = {};
      return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formatted}&key=${this.getApiKey()}`, null)
        .then(response => {
          axiosHeader();
          return response.data.results;
        })
        .catch(err => {
          throw err;
        });
    }
    return false;
  }

  getCommentList(id) {
    return this.request(`${this.getUrl()}/${id}/comments`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveComment(param) {
    return this.request(`${this.getUrl()}/${param.id}/comment`, { comment: param.comment }, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  updateComment(param) {
    return this.request(`${this.getUrl()}/${param.id}/comment/${param.comment.id}`, { comment: param.comment.comment }, 'put')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }


  getImagesList(id) {
    return this.request(`${this.getUrl()}/${id}/images`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveImages(id, params) {
    let formData = new FormData();
    formData = this.setFormData(params, formData);
    formData = this.setFiles(params, formData);
    formData.delete('images');
    return this.request(`${this.getUrl()}/${id}/image`, formData, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteImages(id, imageId) {
    return this.request(`${this.getUrl()}/${id}/image/${imageId}`, null, 'delete')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = {
      city: params.city,
      state: params.state,
      search: params.search,
      status: params.status,
      trashed: params.trashed,
    };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getCities(param) {
    return this.request(`${this.getUrl()}/city`, param)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getIndicators(id, search) {
    const params = {
      to: (search.to) ? search.to : null,
      from: (search.from) ? search.from : null,
    };
    return this.request(`${this.getUrl()}/${id}/indicators`, params)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUserList(id, search) {
    return this.request(`${this.getUrl()}/${id}/users`, { search })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getResellerById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteReseller(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(reseller) {
    const meta = this.getUrlSave(reseller.id, '');
    return this.request(meta.url, reseller, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  attachResellerUser(id, data) {
    return this.request(`${this.getUrl()}/${id}/user`, { email: data }, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  detachResellerUser(id, userId) {
    return this.request(`${this.getUrl()}/${id}/user/${userId}`, null, 'delete')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  attachResellerRepresentatives(id, representativeId) {
    return this.request(`${this.getUrl()}/${id}/representative/${representativeId}`, null, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  detachResellerRepresentatives(id, representativeId) {
    return this.request(`${this.getUrl()}/${id}/representative/${representativeId}`, null, 'delete')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  toggleAccess(id, status) {
    return this.request(`${this.getUrl()}/${id}/access`, { status }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ResellerService();
